// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import LineOutlinedSvg from "@ant-design/icons-svg/es/asn/LineOutlined";
import AntdIcon from '../components/AntdIcon';

var LineOutlined = function LineOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: LineOutlinedSvg
  }));
};

LineOutlined.displayName = 'LineOutlined';
export default React.forwardRef(LineOutlined);